import { CNRTAuthConfig } from './cnrt.auth.config';
import { environment } from '../../environments/environment';

export const authConfig: Array<CNRTAuthConfig> = [
	// CNRT SIA: https://api.cnrt.gob.ar/oidc/.well-known/openid-configuration
	{
		id: 'hydra',
		name: 'cnrt-hydra',
		config: {
			responseType: environment.authConfig.responseType,
			issuer: environment.authConfig.issuer,
			redirectUri: environment.authConfig.redirectUri,
			logoutUrl: environment.authConfig.logoutUrl,
			clientId: environment.authConfig.clientId,
			scope: environment.authConfig.scope,
			strictDiscoveryDocumentValidation: environment.authConfig.strictDiscoveryDocumentValidation,
			disableAtHashCheck: environment.authConfig.disableAtHashCheck,
			customUserinfoEndpoint: environment.authConfig.customUserinfoEndpoint,
		},
	},
];
